<template>
    <div class="dropdown-component">
        <slot name="trigger"></slot>
        <div class="dropdown-container" :class="{ open: open }" @mouseup.stop>
            <button v-if="showClose" class="close-button" @click="close" type="button" aria-label="Close Dropdown">
                <i class="icon-close"></i>
            </button>
            <slot name="option-header"></slot>
            <div class="scroll-container">
                <ul class="dropdown">
                    <slot name="option"></slot>
                </ul>
            </div>
            <slot name="option-footer"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        open: {
            type: Boolean,
            required: true
        },
        showClose: {
            type: Boolean
        }
    },
    created () {
        document.addEventListener('keydown', this.handleKeyDown)
        document.addEventListener('mouseup', this.handleMouseUp)
    },
    destroyed () {
        document.removeEventListener('keydown', this.handleKeyDown)
        document.removeEventListener('mouseup', this.handleMouseUp)
    },
    methods: {
        handleKeyDown (event) {
            if (event.keyCode === 27) {
                this.select(null)
            }
        },
        handleMouseUp () {
            if (this.open) {
                this.select(null)
            }
        },
        close () {
            this.select(null)
        },
        select (value) {
            this.$emit('select', value)
        }
    }
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.dropdown-component {
    display: inline-block;
}

.dropdown-container {
    display: none;
    left: 50vw;
    margin-left: -150px;
    position: absolute;
    width: 300px;
    z-index: 10;
    @media (--mq-large-min) {
        width: 200px;
    }
    &.open {
        display: block;
    }
    & > .scroll-container {
        & > .dropdown {
            list-style-type: none;
            margin: 0;
            padding: 0;
            z-index: 15;
            & > li {
                cursor: pointer;
            }
        }
    }
    & > .close-button {
        position: absolute;
        z-index: 20;
        right: 0px;
        top: 0px;
        padding: 5px;
        display: block;
        cursor: pointer;
        background: none;
        border: none;
        &:hover {
            color: #c12f48;
        }
        &:focus {
            outline: 1px dotted;
        }
    }
}
</style>
